import { Component, ElementRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ORIGEN_VALIDAR_API_SANTANDER, ORIGEN_VALIDAR_CUENTAS_DIGITALES, ORIGEN_VALIDAR_CUENTA_DUPLICADA } from '@constants/cambio-via-pago-properties.constants';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-modal-validar-cuentas',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './modal-validar-cuentas.component.html',
    styleUrls: ['./modal-validar-cuentas.component.scss'],
    standalone: false
})
export class ModalValidarCuentasComponent implements OnInit  {

  @Input() origenValidacion: string= '';
  titulo:string = '';
  parrafo: string = '';
  nombreBoton: string = '';
  checkBox:boolean = false;
  form: FormGroup;
  
  constanteValidarCuentasDigitales: string = ORIGEN_VALIDAR_CUENTAS_DIGITALES;
  constanteValidarCuentasBancarias: string = ORIGEN_VALIDAR_API_SANTANDER;
  constanteValidarCuentaDuplicada: string = ORIGEN_VALIDAR_CUENTA_DUPLICADA;

  constructor(public modal: ModalController,private readonly _fb: FormBuilder,private readonly elementoRef: ElementRef) { 
    this.crearFormulario();
  }
  crearFormulario() {
    this.form = this._fb.group({
      checkValidar: [ false, Validators.required]
    });
  }

  ngOnInit(): void {
    this.setearMensaje();
  }

  botonIngresar() {
    this.modal.dismiss({
      origen: this.origenValidacion 
    });
  }

  botonAgregarOtraCuenta(data: boolean) {
    this.modal.dismiss({
      origen: this.origenValidacion,
      botonIngresar: data
    });
  }

  close(){
    this.modal.dismiss();
  }

  setearMensaje(){
     if(this.origenValidacion === ORIGEN_VALIDAR_CUENTAS_DIGITALES){
        this.titulo = 'Lo sentimos, no podemos ingresar cuentas digitales';
        this.parrafo = 'Por seguridad, no es posible depositar tu pensión en cuentas digitales como Mach, Superdigital, Check, Tenpo, FAN, entre otras';
        this.nombreBoton = 'Agregar otra cuenta';
      }else if(this.origenValidacion === ORIGEN_VALIDAR_API_SANTANDER){
        this.titulo = 'Lo sentimos, no fue posible validar la existencia de la cuenta';
        this.nombreBoton = 'Aceptar';
      }
  }

  get isInvalidForm():boolean {
    return this.form.invalid || this.form.getRawValue().checkValidar === false;
  };



}
